import { DateField, TextField, ValueAutocompleteField } from '@forgeglobal/design-framework'
import { Field } from 'util/SegmentUtils'
import { Field as FinalFormField } from 'react-final-form'
import React from 'react'

export const ValueField: React.FC<{
  multiple: boolean
  options: { label: string; value: string }[]
  fld: Field | null
}> = ({ multiple, fld, options }) => {
  switch (fld?.type) {
    case 'enum':
    case 'boolean':
      return <ValueAutocompleteField label="Value" name="value" multiple={multiple} options={options} />
    case 'datetime':
      return <DateField label="Value" name="value" />
    case 'string':
    case 'number':
    default:
      return <FinalFormField name="value" render={props => <TextField label="Value" {...props} />} />
  }
}
